<template>
    <!--Waiting List Invite Page-->
    <div class="waiting-list-invite-clients">
        <!--Heading-->
        <h3>{{ $ml.get("waitingListInviteClients.title") }}</h3>
        <!--Main content page-->
        <div class="section-wrap">
            <div class="invite-clients-wrap" v-if="!sendNewInvite">
                <!--Send new invite button-->
                <div class="send-invite-button">
                    <h5 class="title-bold">{{ inviteHistory.length > 1 ? "Invites" : "Invite" }} history</h5>
                    <button class="primary-btn extra-small mobile" @click="toggleSendNewInvite()">
                        Send new invite
                    </button>
                </div>
                <div class="invite-history-wrap section-wrap">
                    <div class="invite-history-inner-wrap services-wrap" v-if="inviteHistory.length > 0">
                        <div class="invite-inner-wrap" v-for="info in inviteHistory" :key="info.id">
                            <div class="invite-info">
                                <p class="invite-date">{{ getFormattedDate(info.created_at, "MMMM Do YYYY") }}</p>
                                <p v-if="returnGroupType(info.group_type) != 'all'">
                                    Message sent to {{ info.total_clients }} clients with at least 1 appt on last
                                    {{ returnGroupType(info.group_type) }}
                                </p>
                                <p v-if="returnGroupType(info.group_type) === 'all'">
                                    Message sent to all ({{ info.total_clients }}) clients with at least 1 appt
                                </p>
                                <p class="invite-message">"{{ info.message }}"</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="inviteHistory.length == 0" class="no-history">
                        <p>{{ $ml.get("waitingListInviteClients.noInvites") }}</p>
                    </div>
                    <main-loader v-if="loading"></main-loader>
                    <div class="load-more-wrap" v-if="totalMessagesSent > limit">
                        <button class="primary-btn extra-small mobile" @click="loadMore">Load more</button>
                    </div>
                </div>
                <!--Back to Dashboard-->
                <div class="back-btn-wrap">
                    <router-link class="primary-btn extra-small mobile" :to="{ path: '/app/waiting-list/dashboard' }">
                        {{ $ml.get("general.goBack") }}
                    </router-link>
                </div>
            </div>
            <!--Send New Invite Wrapper-->
            <div class="send-invite-wrap" v-if="sendNewInvite">
                <div v-if="currentSection != 'congratulation'" class="send-invite-wrap">
                    <p>You can invite all your clients to join your WaitList, or a group of them.</p>
                    <!--Checkbox Wrapper-->
                    <fieldset class="invite-checkbox-wrap">
                        <legend class="title-bold">See your options below:</legend>
                        <div class="invite-checkbox" @change="handleGroupNrandMessagesToBuy">
                            <input
                                type="radio"
                                id="all-clients"
                                name="clients"
                                value="all"
                                checked
                                v-model="selectedClientOption"
                            />
                            <label for="all-clients">Invite all clients ({{ activeClients.total_clients }})</label>
                        </div>
                        <div class="invite-checkbox" @change="handleGroupNrandMessagesToBuy">
                            <input
                                type="radio"
                                id="last6"
                                name="clients"
                                value="sixMonths"
                                v-model="selectedClientOption"
                            />
                            <label for="last6"
                                >Invite all clients with at least 1 appt. in last 6 months ({{
                                    activeClients.total_active_clients_last_6_months
                                }})
                            </label>
                        </div>
                        <div class="invite-checkbox" @change="handleGroupNrandMessagesToBuy">
                            <input
                                type="radio"
                                id="last3"
                                name="clients"
                                value="threeMonths"
                                v-model="selectedClientOption"
                            />
                            <label for="last3"
                                >Invite all clients with at least 1 appt. in last 3 months ({{
                                    activeClients.total_active_clients_last_3_months
                                }})
                            </label>
                        </div>
                    </fieldset>
                    <p>
                        This invite will consume {{ nrClients }} text messages(SMS). You have {{ availableSMS }} SMS
                        available.
                    </p>
                    <div
                        class="sms-not-allowed"
                        v-if="availableSMS < nrClients && !loading && !adminDetails.allow_to_buy"
                    >
                        <p>
                            To purchase text messages, please contact us. We will enable this feature for you.
                            <router-link class="main-text-link" :to="{ path: '/app/contact-us' }">
                                Click here to message us.
                            </router-link>
                        </p>
                    </div>
                    <!--Wrapper for buy more messages-->
                    <div class="buy-more-messages-wrap">
                        <div
                            class="buy-more-messages"
                            :class="!adminDetails.allow_to_buy ? 'disabled-button' : ''"
                            v-if="availableSMS < nrClients && !loading"
                        >
                            <p>
                                Sign below to purchase {{ buyMessagesNumber }} SMS for {{ profileCurrency
                                }}{{ getTotalMessageCost() }}. We will charge your credit card ending in
                                {{ defaultCard.last4 }}.
                            </p>
                            <!--Vue Signature Component-->
                            <p class="title-bold">Your signature:</p>
                            <div class="signature-container">
                                <vue-signature
                                    class="signature"
                                    ref="signaturePad"
                                    :sigOption="signatureOption"
                                    :w="screenWidth"
                                    :h="'200px'"
                                    @endStroke="checkIfSigned"
                                >
                                </vue-signature>
                            </div>
                            <!--Clear and Undo Buttons-->
                            <div class="signature-btns-container">
                                <button class="secondary-btn small mobile" @click="clearSignature">Clear</button>
                            </div>
                            <!--Adreement Checkbox-->
                            <div class="checkbox-inputs-container">
                                <div class="input-checkbox">
                                    <div class="input-box">
                                        <input
                                            v-model="isAgree"
                                            @click="checkIfSigned"
                                            type="checkbox"
                                            id="agreement"
                                            name="Agreement"
                                            :value="isAgree"
                                        />
                                    </div>
                                    <label for="agreement" class="checkbox-label-wrap"> I agree with the above </label>
                                </div>
                            </div>
                        </div>
                        <!--Purchase Messages Buttons-->
                        <div class="buy-messages-buttons" v-if="availableSMS < nrClients && !loading">
                            <button
                                class="primary-btn extra-small mobile"
                                :disabled="!isSigned || !isAgree"
                                :class="!isSigned || !isAgree ? 'disabled-button' : ''"
                                @click="chargePayment()"
                            >
                                Purchase
                            </button>
                            <button class="primary-btn extra-small mobile" @click="toggleSendNewInvite()">
                                {{ $ml.get("general.goBack") }}
                            </button>
                        </div>
                    </div>
                    <!--Loader-->
                    <main-loader v-if="loading || sendingInvite" class="section-wrap"></main-loader>
                    <!--Write Your Message Wrapper-->
                    <div class="write-your-message" v-if="availableSMS >= nrClients && !sendingInvite">
                        <label for="story">Invite message (under 280 characters)</label>
                        <textarea
                            v-model="inviteMessage"
                            class="section-wrap"
                            id="story"
                            name="story"
                            rows="5"
                            maxlength="280"
                            cols="33"
                            placeholder="Please write your message"
                        >
                        </textarea
                        ><span>{{ inviteMessage.length }}/280</span>
                        <!--Write Your Message Buttons-->
                        <div class="write-your-message-buttons">
                            <button class="primary-btn extra-small mobile" @click="toggleSendNewInvite()">
                                {{ $ml.get("general.goBack") }}
                            </button>
                            <button class="primary-btn extra-small mobile" @click="sendWaitlistNotifications()">
                               Send Invite 
                            </button>
                        </div>
                    </div>
                </div>
                <!--Congratulation-->
                <div class="congratulation-message" v-if="currentSection === 'congratulation'">
                    <enroll-congratulation
                        :text="`Sent! You have invited ${nrClients} clients to join your waitlist.`"
                        buttonText="Home"
                        :goToDashboard="true"
                    >
                    </enroll-congratulation>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vueSignature from "vue-signature";
import $ from "jquery";
import store from "../../../services/vuex";
import eventBus from "../../../services/event_bus";
import api from "../../../services/api_endpoints";
import EnrollCongratulation from "./parts/enroll_congratulation.vue";
import moment from "moment";
import MainLoader from "../general-components/main_loader.vue";
import messages from "../../../services/messages";

export default {
    data() {
        return {
            inviteDetails: {},
            sendNewInvite: false,
            isAgree: false,
            isSigned: false,
            signatureOption: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },
            screenWidth: "",
            braintreeCards: {},
            currentSection: "",
            inviteMessage: "",
            activeClients: {},
            selectedClientOption: "all",
            nrClients: 0,
            availableSMS: 0,
            availableEmails: 0,
            inviteHistory: {},
            loading: false,
            smsAllowedCountries: [],
            buyMessagesNumber: 0,
            messageType: "sms",
            emailCost: process.env.VUE_APP_EMAIL_COST,
            offset: 0,
            limit: 5,
            totalMessagesSent: 0,
            minSMSBuyNumber: 100,
            defaultMessage:
                "Thank you for your interest in my services! My schedule is currently full, but I'd love to add you to my waitlist. You'll be notified as soon as an appointment becomes available, so you can book your spot at your convenience.",
            profileCurrency: "$",
            sendingInvite: false,
        };
    },
    computed: {
        defaultCard: {
            get: function () {
                return store.state.defaultCard;
            },
            set: function (value) {
                store.commit("setDefaultCard", value);
            },
        },
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.getScreenWidth();

        $(document).on("click", ".signature-container canvas", () => {
            this.checkIfSigned();
        });

        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.checkUserCard();
            self.onAdminDetailsLoad();
        });

        this.smsAllowedCountries = process.env.VUE_APP_SMS_ALLOWED_COUNTRIES.split(",");

        this.checkIfSigned();
        this.changeCurrentSection("buy-more-messages");
        this.getActiveClientCountsByPeriod();
        this.getCampaignSettings();
        this.getInvitesHistory();
        this.hasAvailableMessages();
    },
    components: {
        vueSignature,
        EnrollCongratulation,
        MainLoader,
    },
    methods: {
        toggleSendNewInvite() {
            this.sendNewInvite = !this.sendNewInvite;
        },
        clearSignature() {
            var _this = this;
            _this.$refs.signaturePad.clear();
            this.isSigned = false;
        },
        undoSignature() {
            var _this = this;
            _this.$refs.signaturePad.undo();
            this.checkIfSigned();
        },
        getScreenWidth() {
            if (window.innerWidth < 375) {
                this.screenWidth = "258px";
            }
            if (window.innerWidth >= 375) {
                this.screenWidth = "300px";
            }

            if (window.innerWidth > 620) {
                this.screenWidth = "536px";
            }

            if (window.innerWidth > 991) {
                this.screenWidth = "700px";
            }
        },
        checkIfSigned() {
            const signaturePad = this.$refs.signaturePad;

            // Check if the signature pad is empty
            if (signaturePad && !signaturePad.isEmpty()) {
                this.isSigned = true; // Enable the next button if signature is drawn
            } else {
                this.isSigned = false; // Disable the next button if signature is empty
            }
        },
        checkUserCard() {
            this.loaded = true;

            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {
                if (response.data.error == true || !response.data.response.length) {
                    this.hasCard = false;
                    this.loaded = false;

                    return;
                }

                this.hasCard = true;
                this.braintreeCards = response.data.response;
                this.loaded = false;

                this.checkDefaultCard();
            });
        },
        checkDefaultCard(card_id = "") {
            this.braintreeCards.forEach((card) => {
                if (card_id === card.payment_method_token) {
                    this.selectedCard = card.payment_method_token;
                    this.defaultCard = card;
                } else if (card.default == true) {
                    this.selectedCard = card.payment_method_token;
                    this.defaultCard = card;
                }
            });
        },
        onAdminDetailsLoad: function () {
            this.handleGroupNrandMessagesToBuy();
        },
        costPerPackMethod(pack) {
            return this.costPerPack = (this.costPerSms * pack).toFixed(2);
        },
        changeCurrentSection(section) {
            this.currentSection = section;
        },
        getActiveClientCountsByPeriod() {
            this.$http.get(api.actions.get_active_client_counts_by_period).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.activeClients = response.body;
                this.nrClients = response.body.total_clients;
                this.lastSentMessage = response.body.last_sent_message;
                this.inviteMessage = this.lastSentMessage != "" ? this.lastSentMessage : this.defaultMessage;

                this.getSelectedGroupNumber();
            });
            return;
        },
        sendWaitlistNotifications() {
            if(this.hasLink(this.inviteMessage)) {
                messages.errorMessage(messages.ERROR_MESSAGES.LINKS_FORBIDDEN);
                return;
            };
            
            this.sendingInvite = true;

            let data = {
                type: this.selectedClientOption,
                message: this.inviteMessage,
            };

            this.$http.post(api.actions.send_waitlist_notifications, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.changeCurrentSection("congratulation");
                this.sendingInvite = false
            });
            return;
        },
        getCampaignSettings: function () {
            this.$http.get(api.actions.get_marketing_campaign_settings).then(
                function (response) {
                    if (typeof response.data.settings !== "undefined") {
                        this.availableSMS = response.data.settings.available_sms;
                        this.availableEmails = response.data.settings.available_emails;

                        this.loading = false;
                    }
                }.bind(this)
            );
        },
        getInvitesHistory() {
            this.loading = true;
            this.$http
                .get(api.actions.get_invites_history + "?offset=" + this.offset + "&limit=" + this.limit)
                .then((response) => {
                    if (response.data.error == true) {
                        return;
                    }

                    this.inviteHistory = response.data.history;
                    this.totalMessagesSent = response.data.total;
                    this.loading = false;

                    this.goToInvite();
                });
            return;
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },
        hasAvailableMessages() {
            let available = this.availableSMS > this.nrClients;

            return available;
        },
        getSelectedGroupNumber() {
            switch (this.selectedClientOption) {
                case "all":
                    this.nrClients = this.activeClients.total_clients;
                    break;
                case "sixMonths":
                    this.nrClients = this.activeClients.total_active_clients_last_6_months;
                    break;
                case "threeMonths":
                    this.nrClients = this.activeClients.total_active_clients_last_3_months;
                    break;
            }
        },
        isCountrySMSAllowed() {
            if (!this.adminDetails.profile) {
                return false;
            }

            let profileCountryId = this.adminDetails.profile.country_id;
            let countriesAllowed = this.smsAllowedCountries;

            return countriesAllowed.includes(profileCountryId.toString());
        },
        handleGroupNrandMessagesToBuy() {
            this.getSelectedGroupNumber();
            this.ensureMinimumMessagesToBuy();
        },
        ensureMinimumMessagesToBuy() {
            if (this.nrClients < this.minSMSBuyNumber) {
                this.buyMessagesNumber = this.minSMSBuyNumber;
            } else {
                this.buyMessagesNumber = this.nrClients - this.availableSMS;
            }

            if (this.buyMessagesNumber < this.minSMSBuyNumber) {
                this.buyMessagesNumber = this.minSMSBuyNumber;
            }
        },
        getTotalMessageCost() {
            this.ensureMinimumMessagesToBuy();

            if (this.smsAllowedCountries.indexOf(this.adminDetails.profile.country_id.toString()) > -1) {
                this.costPerSms = parseFloat(process.env["VUE_APP_SMS_COST_" + this.adminDetails.profile.country_id]);
            } else {
                this.costPerSms = parseFloat(process.env["VUE_APP_SMS_COST_0"]);
            }

            return (this.costPerSms * this.buyMessagesNumber).toFixed(2);
        },
        chargePayment() {
            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {
                if (response.data.error == true || !response.data.response.length) {
                    return;
                }

                let payment_method = response.data.response[0];

                response.data.response.forEach((el) => {
                    if (el.default) {
                        payment_method = el;
                    }
                });

                let fields = {
                    number: this.buyMessagesNumber,
                    type: this.messageType,
                    payment_method_token: payment_method.payment_method_token,
                    signature: this.$refs.signaturePad.save(),
                    dataImage: 1,
                };

                this.loading = true;

                this.$http.post(api.actions.charge_marketing_campaign_payment, fields).then(() => {
                    setTimeout(() => {
                        this.getCampaignSettings();
                        this.hasAvailableMessages();
                    }, 2000);
                });
            });
        },
        returnGroupType(type) {
            let typeText = "";

            if (type === "sixMonths") {
                typeText = "six months";
            } else if (type === "threeMonths") {
                typeText = "three months";
            } else if (type === "all") {
                typeText = "all";
            }

            return typeText;
        },
        loadMore() {
            if (this.totalMessagesSent < this.limit) {
                return;
            }

            this.limit = this.limit + 5;
            this.getInvitesHistory();
        },
        goToInvite() {
            if (this.inviteHistory.length === 0 && this.adminDetails.profile && this.adminDetails.profile.currency) {
                this.toggleSendNewInvite();
            }
        },
        hasLink(text) {
            if (typeof text !== "string" || !text.trim()) return false;

            const urlPattern = /(?:(?:https?|ftp):\/\/|www\.)[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?/gi;
            return urlPattern.test(text);
        }
    },
};
</script>
